"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _StyledSettingsComponents = require("./StyledSettingsComponents");

var _Row = _interopRequireDefault(require("./Row"));

var _ColorPicker = _interopRequireDefault(require("./ColorPicker"));

var _ImageLoader = _interopRequireDefault(require("./ImageLoader"));

var _CurrentContext = _interopRequireDefault(require("../context/CurrentContext"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _Range = _interopRequireDefault(require("./Range"));

var _BackgroundAlignToggler = _interopRequireDefault(require("./BackgroundAlignToggler"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var BackgroundPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(BackgroundPanel, _Component);

  function BackgroundPanel() {
    _classCallCheck(this, BackgroundPanel);

    return _possibleConstructorReturn(this, _getPrototypeOf(BackgroundPanel).apply(this, arguments));
  }

  _createClass(BackgroundPanel, [{
    key: "render",
    value: function render() {
      var postFileUrl = this.props.postFileUrl;
      return _react.default.createElement(_CurrentContext.default.Consumer, null, function (_ref) {
        var settings = _ref.settings,
            onChangeSettingsProp = _ref.onChangeSettingsProp;
        return _react.default.createElement(_StyledSettingsComponents.Panel, null, _react.default.createElement(_Row.default, {
          label: "\u0424\u043E\u043D"
        }, _react.default.createElement(_ImageLoader.default, {
          prop: "background",
          postFileUrl: postFileUrl,
          removable: true
        })), !settings.pattern && settings.background && _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Row.default, {
          label: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C"
        }, _react.default.createElement(_Checkbox.default, {
          prop: "coverBackground"
        })), _react.default.createElement(_Row.default, {
          label: "\u0412\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435"
        }, _react.default.createElement(_BackgroundAlignToggler.default, {
          align: settings.backgroundAlign,
          onChange: onChangeSettingsProp
        }))), _react.default.createElement(_Row.default, {
          label: "\u0426\u0432\u0435\u0442 \u0444\u043E\u043D\u0430"
        }, _react.default.createElement(_ColorPicker.default, null)), settings.background && _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Row.default, {
          label: "\u041F\u0430\u0442\u0442\u0435\u0440\u043D"
        }, _react.default.createElement(_Checkbox.default, {
          prop: "pattern"
        })), settings.pattern && _react.default.createElement(_Row.default, {
          label: "\u041C\u0430\u0441\u0448\u0442\u0430\u0431"
        }, _react.default.createElement(_Range.default, {
          prop: "patternScale"
        }))));
      });
    }
  }]);

  return BackgroundPanel;
}(_react.Component);

exports.default = BackgroundPanel;